import { KnownOrderDtoStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { alpha, Avatar, Grid, Paper, Typography } from '@mui/material';
import { orderStatusBackgroundColors } from '../../../../orders/orders.constants';
import { useStatusCountCardSmallStyles } from './status-count-card-small.styles';
import { StatusCountCardSmallPlaceholder } from './status-count-card-small-placeholder.component';
import { Link } from 'react-router-dom';
import { SVGIconComponent } from '../../../../../ui/components/pure/icons/types';
import { useCurrentProject } from '../../../../../core/context/project.context';
import { getOrderStatusLabel } from '../../../../../core/util/status-label.util';
import { orderStatusCountCardSubtitleMap } from '../../../dashboard.constants';

export function StatusCountCardSmall({
  count,
  status,
  link,
  Icon,
  isLoading,
  showSubtitle = true
}: {
  status?: string;
  count?: number;
  link?: string;
  Icon?: SVGIconComponent;
  isLoading: boolean;
  showSubtitle: boolean;
}) {
  const classes = useStatusCountCardSmallStyles();
  const { bookingFlowType } = useCurrentProject();

  if (isLoading || !status) {
    return <StatusCountCardSmallPlaceholder />;
  }

  const iconColor = orderStatusBackgroundColors[status as KnownOrderDtoStatus];
  const title = getOrderStatusLabel(status as KnownOrderDtoStatus, bookingFlowType);
  const subtitle = orderStatusCountCardSubtitleMap[status as KnownOrderDtoStatus];

  return (
    <Link to={link || '#'} className={classes.link}>
      <Paper elevation={1} className={[classes.card, classes.clickable].join(' ')}>
        <Grid container style={{ height: '100%' }}>
          {/* Left side */}
          <Grid
            container
            size={9}
            sx={{
              justifyContent: 'space-between',
              flexDirection: 'column'
            }}
          >
            <Grid>
              <Typography variant="h6" gutterBottom className={classes.title}>
                {title === 'Cancelled & Retrieved' ? <>Cancelled &&nbsp;Retrieved</> : title}
              </Typography>
              {showSubtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
            </Grid>
            <Grid>
              <Typography className={classes.count}>{count ? count.toLocaleString() : 0}</Typography>
            </Grid>
          </Grid>
          {/* Rigth side */}
          <Grid className={classes.rightSide} size={3}>
            <Avatar className={classes.avatar} style={{ backgroundColor: alpha(iconColor, 0.15) }}>
              {Icon ? <Icon className={classes.icon} color={iconColor} /> : <> </>}
            </Avatar>
          </Grid>
        </Grid>
      </Paper>
    </Link>
  );
}
